import { EmploymentType as SharedEmploymentType } from "@shared/schema";

// Canonical values (slugs) used across the app
export type EmploymentTypeValue =
  | SharedEmploymentType.FULL_TIME
  | SharedEmploymentType.PART_TIME
  | SharedEmploymentType.VARIABLE_HOUR
  | SharedEmploymentType.SEASONAL
  | SharedEmploymentType.CONTRACTOR
  | SharedEmploymentType.INTERN;

// Short, human-friendly labels for UI
export const EMPLOYMENT_TYPE_OPTIONS_SHORT: { value: EmploymentTypeValue; label: string }[] = [
  { value: SharedEmploymentType.FULL_TIME, label: "Full-Time" },
  { value: SharedEmploymentType.PART_TIME, label: "Part-Time" },
  { value: SharedEmploymentType.VARIABLE_HOUR, label: "Variable Hour" },
  { value: SharedEmploymentType.SEASONAL, label: "Seasonal" },
  { value: SharedEmploymentType.CONTRACTOR, label: "Contractor" },
  { value: SharedEmploymentType.INTERN, label: "Intern" },
];

const aliasMap: Record<string, EmploymentTypeValue> = {
  // canonical (computed keys)
  [SharedEmploymentType.FULL_TIME]: SharedEmploymentType.FULL_TIME,
  [SharedEmploymentType.PART_TIME]: SharedEmploymentType.PART_TIME,
  [SharedEmploymentType.VARIABLE_HOUR]: SharedEmploymentType.VARIABLE_HOUR,
  [SharedEmploymentType.SEASONAL]: SharedEmploymentType.SEASONAL,
  [SharedEmploymentType.CONTRACTOR]: SharedEmploymentType.CONTRACTOR,
  [SharedEmploymentType.INTERN]: SharedEmploymentType.INTERN,
  // common variants (avoid duplicating canonical strings)
  "full time": SharedEmploymentType.FULL_TIME,
  "fulltime": SharedEmploymentType.FULL_TIME,
  "part time": SharedEmploymentType.PART_TIME,
  "parttime": SharedEmploymentType.PART_TIME,
  "variable hour": SharedEmploymentType.VARIABLE_HOUR,
  "variable": SharedEmploymentType.VARIABLE_HOUR,
  "temp": SharedEmploymentType.SEASONAL,
  "temporary": SharedEmploymentType.SEASONAL,
  "contract": SharedEmploymentType.CONTRACTOR,
  "contract-based": SharedEmploymentType.CONTRACTOR,
};

export function normalizeEmploymentType(raw?: string | null): EmploymentTypeValue | undefined {
  if (!raw) return undefined;
  const key = String(raw).trim().toLowerCase();
  return aliasMap[key];
}

export function formatEmploymentType(raw?: string | null): string {
  const norm = normalizeEmploymentType(raw);
  if (!norm) return raw || "Not provided";
  const found = EMPLOYMENT_TYPE_OPTIONS_SHORT.find(o => o.value === norm);
  return found ? found.label : raw || "Not provided";
}
